import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjsUtils from '@attain-apps/rxjs-utils'
import * as rxjs from 'rxjs'

import type * as me from '../../../me'
import type { Feature } from '../feature'
import * as gql from '../gql'

export const loadFeed = store.effects.create(
  (feature: Feature, meFeature: me.Feature) =>
    feature.actions.loadFeed.request.observe().pipe(
      rxjsUtils.latestFrom(action => ({
        action: rxjs.of(action),
        context: meFeature.contexts.selectors.zoneContext.asObservable,
      })),
      rxjs.mergeMap(({ action, context }) =>
        context
          ? gql.queries.checkInResponses.executor(context).pipe(
              rxjs.map(response =>
                feature.actions.loadFeed.success.from(action).create({
                  request: action.data,
                  response,
                }),
              ),
              rxjs.catchError(error =>
                rxjs.of(
                  feature.actions.loadFeed.error.from(action).create({
                    error,
                    request: action.data,
                  }),
                ),
              ),
            )
          : rxjs.of(
              feature.actions.loadFeed.cancellation.from(action).create({
                reason: 'Not in a valid zone context',
                request: action.data,
              }),
            ),
      ),
    ),
)
